import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

import reducers from './reducers';
import mainSaga from './main-saga';

const NODE_ENV = process.env.NODE_ENV || 'development';

const configureStore = (initialState = {}) => {
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [applyMiddleware(sagaMiddleware), applyMiddleware(thunk)];
    if (NODE_ENV === 'development') {
        middlewares.push(applyMiddleware(createLogger()));
    }
    const enhancer = compose(...middlewares);
    const store = createStore(reducers, initialState, enhancer);
    sagaMiddleware.run(mainSaga);
    return store;
};

export default configureStore;
